// Remaining 
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

interface AuthGuardProps {
  redirectPath?: string;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ redirectPath = '/' }) => {
  const isAuthenticated = !!localStorage.getItem('auth_token');

  if (!isAuthenticated) {
    return <Navigate to={redirectPath} />;
  }

  return <Outlet />;
};

export default AuthGuard;
